import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { LocationOn as LocationIcon } from "@mui/icons-material";
import { SiteVisitVenue } from "./site-visit.types";

interface VenueDetailsProps {
  venue: SiteVisitVenue;
}

const VenueDetails: React.FC<VenueDetailsProps> = ({ venue }) => {
  const fullAddress = [
    venue.address_one,
    venue.address_two,
    venue.suburb,
    venue.city,
    venue.country,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 2,
        mb: 2,
      }}
    >
      <Typography variant="subtitle2" fontWeight={600} gutterBottom>
        Venue Details
      </Typography>

      <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
        {venue.name}
      </Typography>

      {fullAddress && (
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
          <LocationIcon fontSize="small" color="action" sx={{ mt: 0.25 }} />
          <Typography variant="body2" color="text.secondary">
            {fullAddress}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default VenueDetails;
